import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import mainBannner from "../../assets/images/banners/mainBanner.jpg";
// import mainBannnerMobile from "../../assets/images/banners/mainBannerMobile.jpg";
import MobileBanner from "../../assets/images/banners/mobile.jpeg";
import mainBannner from "../../assets/images/banners/desktop.jpeg";
import SpinWheel from "../SpinWheel/spin-wheel";
import SpinWheelBg from "../../assets/images/banners/spinWheel.png";

const HomeBanner = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    consent: true,
  });
  const [loading, setLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showPopup, setShowPopup] = useState(true);

  const validateForm = () => {
    if (!formData.name.trim()) {
      toast.error("Name is required");
      return false;
    }
    if (!formData.mobile.trim()) {
      toast.error("Phone number is required");
      return false;
    }
    if (!/^\d{10}$/.test(formData.mobile)) {
      toast.error("Enter a valid 10-digit phone number");
      return false;
    }
    if (!formData.consent) {
      toast.error("Please authorize to submit");
      return false;
    }
    return true;
  };

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      await fetch("https://cms.gphomes.in/api/contact-form", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "gp-web-token": "sdswkhsADWRjfh9Thwn8rn6Mybd",
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          mobile: formData.mobile,
          location: "Popup Enquiry",
          message: "Popup Enquiry",
        }),
      });

      setFormData({ name: "", email: "", mobile: "", consent: true });
      localStorage.setItem("popupSubmittedAt", Date.now().toString());
      setShowConfirmation(true);
      toast.success("Form submitted successfully!");
      navigate("/thank-you");
      setTimeout(() => {
        setShowPopup(false);
        setShowConfirmation(false);
      }, 3000);
    } catch (error) {
      console.error("Form submission failed:", error);
      toast.error("Failed to submit form. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="kingdom-of-joy">
      <ToastContainer position="top-center" autoClose={3000} />

      <div className="banner-section">
        <div className="banner-container">
          <picture>
            <source media="(min-width: 991px)" srcSet={mainBannner} />
            <source media="(max-width: 990px)" srcSet={MobileBanner} />
            <img
              src={mainBannner}
              alt="Kingdom of Joy Banner"
              className="img-fluid"
            />
          </picture>
        </div>

        {/* <div
          className="form-section"
          id="homeform"
        >
          <SpinWheel />
        </div> */}
      </div>
    </div>
  );
};

export default HomeBanner;
